<section class="section" style="background-color: #ffffff">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-12">
        <p>&nbsp;</p>
        <div class="section-title text-center mb-4 pb-2">
          <h4 class="title mb-4">How To Verify Identity</h4>
          <p class="text-muted">
            This video will explain step by step how to verify you identity
          </p>
        </div>
      </div>
    </div>

    <div class="row justify-content-center">
      <div class="col-12 text-center">
        <iframe
          width="560"
          height="315"
          src="https://www.youtube.com/embed/Er4VBblnq1U"
          title="YouTube video player"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
        ></iframe>
      </div>
    </div>
  </div>
</section>
